import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loadingAssets: string;
    manageMembers: string;
    memberCount: (count: number) => string;
    projectMenuLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria-label for assets section loading state */
            loadingAssets: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticAssets.loadingAssets?c=2azb8q18os3w5", defaultMessage: "Loading assets" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the manage members option for Project Menu */
            manageMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticAssets.manageMembers?c=tklamxbrwz1l", defaultMessage: "Manage Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Number of members in this project for the ProjectHeader */
            memberCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "StaticAssets.memberCount?c=bvpy5tub1te1", defaultMessage: "{count, plural, one {1 Member} other {{count, number} Members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible name for the project header's menu dialog */
            projectMenuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "StaticAssets.projectMenuLabel?c=g4usxrt28mav", defaultMessage: "Project menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
